const layoutMessages = {
  topNavigation: {
    serviceProvider: ['layout>>topNavigation>>serviceProvider', 'Usługę\nzapewnia']
  }
}

export default layoutMessages
